
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "src/utils/constants";
import { getClassnames } from "src/utils/utils";
import { useHeaderIconType } from "../utils/useHeaderIconType";
import { DismissButton } from "../common/DismissButton";
import { ArrowBackButton } from "../common/ArrowBackButton";
import "./zara-header.scss";

const ZaraHeader = () => {
  const { pathname } = useLocation();
  const { headerIconType } = useHeaderIconType();

  const classNameNavBar = getClassnames({
    ["nav-zds-main-menu"]: pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`),
    ["nav-zds"]: true,
  });

  return (
    <header className={classNameNavBar}>
      <ul className="nav-zds__header">
        <li>
          {headerIconType === "arrow" ? (
            <ArrowBackButton />
          ) : (
            <DismissButton
              ariaLabel={
                headerIconType === "close"
                  ? t("call_alert_close")
                  : t("close_cart_button")
              }
            />
          )}
        </li>
      </ul>
    </header>
  );
};

export default ZaraHeader;
